import { render, staticRenderFns } from "./HandlerDisputes.vue?vue&type=template&id=0fdd198c&scoped=true"
import script from "./HandlerDisputes.vue?vue&type=script&lang=js"
export * from "./HandlerDisputes.vue?vue&type=script&lang=js"
import style0 from "./HandlerDisputes.vue?vue&type=style&index=0&id=0fdd198c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd198c",
  null
  
)

export default component.exports